import React from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { ModifyReasonCardOCS } from './ModifyReasonCardOCS'
import { InventoryLogType } from '@getgreenline/inventory/build/models/inventoryLog'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { BLAZE_COMPANY } from '../../../../constants/general'
import { ProvinceEnum } from '@getgreenline/companies/build/models'
import { Col, Row } from 'antd-v4'

interface InjectedProps {
  currentCompanyStore?: CurrentCompanyStore
}

interface Props {
  newLogType: InventoryLogType | undefined
  setType: (type: InventoryLogType) => void
}

const _InventoryReductionOptions = ({
  currentCompanyStore,
  newLogType,
  setType,
}: Props & InjectedProps) => {
  const isCompanyProvinceNotON = currentCompanyStore?.company?.province !== ProvinceEnum.ON

  return (
    <>
      <Row gutter={[16, 24]}>
        <Col span={12} className='gutter-row'>
          <ModifyReasonCardOCS
            title='Returned'
            description='Select if you returned this product to your supplier.'
            checked={newLogType === InventoryLogType.RETURN}
            onClick={() => setType(InventoryLogType.RETURN)}
          />
        </Col>
        <Col span={12} className='gutter-row'>
          <ModifyReasonCardOCS
            title='Destroyed'
            description='Select if you destroyed this product.'
            checked={newLogType === InventoryLogType.DESTROYED}
            onClick={() => setType(InventoryLogType.DESTROYED)}
          />
        </Col>
        <Col span={12} className='gutter-row'>
          <ModifyReasonCardOCS
            title='Lost'
            description='Select if you lost this product.'
            checked={newLogType === InventoryLogType.LOST}
            onClick={() => setType(InventoryLogType.LOST)}
          />
        </Col>
        <Col span={12} className='gutter-row'>
          <ModifyReasonCardOCS
            title='Audit'
            description='Select if you do not know the reason.'
            checked={newLogType === InventoryLogType.AUDIT}
            onClick={() => setType(InventoryLogType.AUDIT)}
          />
        </Col>
        {isCompanyProvinceNotON && (
          <Col span={12} className='gutter-row'>
            <ModifyReasonCardOCS
              title='Sale'
              description={`Select if you sold this product but did not record it on ${BLAZE_COMPANY}.`}
              checked={newLogType === InventoryLogType.SALE}
              onClick={() => setType(InventoryLogType.SALE)}
            />
          </Col>
        )}
      </Row>
    </>
  )
}

export const InventoryReductionOptions = inject('currentCompanyStore')(
  observer(_InventoryReductionOptions),
)
